<template>
    <el-timeline class="sms-log">
        <div v-if="!no_data" style="overflow: scroll; height: 90vh;" @scroll="load">
        <!-- <div v-if="!no_data"> -->
            <el-timeline-item :timestamp="item.created_at" placement="top" v-for="(item, index) in tableData"
                :key="index">
                <el-card>
                    <div class="send">
                        <span>发送内容:</span>
                        <span>{{ item.content }}</span>
                    </div>
                    <div class="send-to-phone send">
                        <span>发送至手机:</span>
                        <span>{{ item.phone }}</span>
                        <span v-if="item.code_desc" :style="getItemStyle(item.resp_code)">({{ item.code_desc }})</span>
                    </div>
                    <div class="answer">
                        <span>客户回复内容:</span>
                        <div v-for="(i, ind) in item.log" class="content-up">
                            <p>{{ i.content_up }}</p>
                            <p>{{ i.answer_time }}</p>
                        </div>
                    </div>
                </el-card>
            </el-timeline-item>
            <div v-if="!go_on" style="text-align: center;">
                ~没有更多数据了
            </div>
        </div>
        <div v-else style="text-align: center;">
            没有数据!
        </div>
    </el-timeline>
</template>

<script>
export default {
    name: 'SmsLog',
    props: {
        id: {
            type: Number
        },
        all: {
            type: Boolean
        },
    },
    data() {
        return {
            hyperfHost:
                process.env.NODE_ENV === "development"
                    ? "http://127.0.0.1:9501/v1/"
                    : "https://qyh-next-server.zhang66.cn/v1/",
            npage: 1,
            tableData: [],
            go_on: null,
            no_data: null,
        }
    },
    watch: {
        id: {
            immediate: true,
            handler(n) {
                if (n) {
                    this.loadTable()
                } else {
                    this.npage = 1
                    this.tableData = []
                }
            }
        }
    },
    methods: {
        loadTable() {
            this.$axios.get(`${this.hyperfHost}api/call_task/sms_log?page=${this.npage}`, {
                params: {
                    loadingClose: true,
                    id: this.id,
                    all: this.all
                }
            }).then(({ data }) => {
                if (data.code === 0) {
                    this.tableData = [...this.tableData, ...data.data]
                    if (!this.tableData.length) {
                        this.no_data = true
                    } else {
                        this.no_data = null
                    }
                    if (!data.data.length) {
                        this.go_on = false
                    } else {
                        this.go_on = true
                    }
                }
            }).catch()
        },
        load(e) {
            const scrollTop = e.target.scrollTop // 滚动条滚动时，距离顶部的距离
            const windowHeight = e.target.clientHeight // 可视区的高度
            const scrollHeight = e.target.scrollHeight // 滚动条的总高度
            if (Math.floor(scrollTop + windowHeight) >= scrollHeight && this.go_on) {
                this.npage++
                this.loadTable()
            }
        },
        getItemStyle(resp) {
            return {
                color: resp === 'DELIVRD' ? '#67C23A' : '#F56C6C'
            }
        }
    },
}
</script>

<style scoped>
.sms-log .send-to-phone {
    margin-top: 0.2rem;
}

.sms-log .answer {
    margin-top: 0.2rem;
}

.sms-log .content-up {
    margin-top: 0.2rem;
}

.sms-log .content-up p {
    margin-top: 0.1rem;
}
.sms-log .send {
    color: #409EFF
}
.sms-log .answer {
    color: #E6A23C

}
</style>


// WEBPACK FOOTER //
// src/pages/cloudClue/Components/SmsLog.vue